

export default { outboundEdiTypes: { instruction: 2 } };